module.exports = __webpack_public_path__ + "static/media/07.0353dee1.jpg";